import Vue from 'vue'
import VueRouter from 'vue-router'
import Menu from './menu'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/reservation/info'
  },
  {
    name: 'reservation',
    path: '/reservation/info',
    component: () => import('@/views/reservation/Index.vue')
  },
  {
    path: '/manage/reservation',
    component: () => import('@/views/manage/reservation/Index.vue')
  },
  {
    path: '/manage/collectPoint',
    component: () => import('@/views/manage/collectPoint/Index.vue')
  },
  {
    path: '/manage/advertising',
    component: () => import('@/views/manage/advertising/Index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

Vue.use(Menu, {
  router
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
